<template>
	<nav :class="{'hidden-nav': isScrollingDown}" class="navbar">
		<div class="w-full grid grid-cols-[1fr_auto_1fr] items-center">
			<div class="col-start-2 flex justify-center">
				<h1 class="text-2xl">Flower Shop</h1>
			</div>
			<div class="ms-auto">
        <button
         @click="toggleMenu"
         :class="{ active: isMenuOpen }"
         class="menu-toggle p-4"
         >
          <div>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        
        <DropdownMenu :isOpen="isMenuOpen" />
      </div>
		</div>
	</nav>
</template>

<script>
import DropdownMenu from './DropdownMenu.vue';

export default {
  components: {
    DropdownMenu,
  },
  data() {
    return {
      isScrollingDown: false, // Tracks whether the navbar should be hidden
      lastScrollTop: 0, // Tracks the last scroll position
      timer: null, // Timer to delay hiding the navbar
      isMenuOpen: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    clearTimeout(this.timer); // Clear timer when the component is destroyed
  },
  methods: {
    handleScroll() {
      const currentScroll = window.scrollY; 

      if (currentScroll > this.lastScrollTop) {
        // Scrolling down
        clearTimeout(this.timer); // Clear any existing timer
        this.timer = setTimeout(() => {
          this.isScrollingDown = true; // Hide the navbar after 1 second
        }, 100);
      } else {
        // Scrolling up
        clearTimeout(this.timer); // Cancel hiding
        this.isScrollingDown = false; // Show the navbar immediately
      }

      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Prevent negative scroll values
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  },
};
</script>

<style lang="scss">
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease; /* Smooth hide animation */
  z-index: 10;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.hidden-nav {
  transform: translateY(-100%); /* Move the navbar out of view */
}

.menu-toggle {
  div {
    position: relative;
    width: 20px;
    height: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    span {
      display: block;
      width: 100%;
      height: 2px;
      background: #333;
      border-radius: 1px;
      transition: all 0.3s ease;
    }
  }

  &.active div span {
    &:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }

    &:nth-child(2) {
      opacity: 0;
    }

    &:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}
</style>